import { render, staticRenderFns } from "./WorkIconButton.vue?vue&type=template&id=214dbe5e&scoped=true"
import script from "./WorkIconButton.vue?vue&type=script&lang=js"
export * from "./WorkIconButton.vue?vue&type=script&lang=js"
import style0 from "./WorkIconButton.vue?vue&type=style&index=0&id=214dbe5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214dbe5e",
  null
  
)

export default component.exports